import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEdit as faEditRegular } from "@fortawesome/pro-regular-svg-icons"
import { faEdit as faEditSolid } from "@fortawesome/free-solid-svg-icons"
import "./EditIcon.css"

/**
 * Reusable edit icon for the curriculum edit buttons. Will darken when its
 * parent button is hovered, but not when an interactive element within the
 * parent is hovered
 * @param {boolean} active - whether the icon should be styled as "active" 
 * regardless of hover state. If true, will override the value of **disabled**
 * @param {boolean} disabled - whether the icon should be stayled as "inactive"
 * regardless of hover state 
 * @param {string} className - css class used for any custom styles
 * @returns {JSX.Element}
 */
const EditIcon = ({ active = false, disabled = false, className = "" }) => {
  return (
    <div className={`curriculum-edit-icon ${className}`}>
      {!active && (
        <FontAwesomeIcon icon={faEditRegular} className={(disabled && !active) ? "show-always" : "show-by-default"} />
      )}
      {(!disabled || active) && (
        <FontAwesomeIcon icon={faEditSolid} className={active ? "show-always" : "show-on-hover"} />
      )}
    </div>
  )
}

export default EditIcon
